import React, { createContext, useRef, useEffect, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const CodeContext = createContext('');

export const PayPalVerificationCodeProvider: React.FC = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const codeParam = queryParams.get('code');
  const scopeParam = queryParams.get('scope');
  const codeRef = useRef(codeParam);

  useEffect(() => {
    if (codeParam && scopeParam && !location.pathname.toLowerCase().includes('stripe')) {
      queryParams.delete('code');
      queryParams.delete('scope');
      history.replace({ search: queryParams.toString() });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [codeParam, scopeParam]);

  return <CodeContext.Provider value={codeRef.current || ''}>{children}</CodeContext.Provider>;
};

export const usePayPalVerificationCode = () => useContext(CodeContext);
